import { ChakraProvider, Box, Center, Text } from '@chakra-ui/react';

export default function Soon() {
  return (
    <Center w='100%' h='60vh'>
      <Text fontSize={{ base: '20px', md: '40px' }}>Coming Soon ...</Text>
    </Center>
  );
}
